import register from '../../../../global/js/registry';
export default register('o-job-offers', () => import(/* webpackMode: "lazy" */ './o-job-offers.controller'));
